package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import ru.chm.gradereport.platform.currentDateIso
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.AppTextField
import ru.chm.gradereport.ui.components.DatePickerField
import ru.chm.gradereport.ui.components.PrimaryButton
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.theme.GradeTheme

@Composable
internal fun AddSessionDialog(
    onDismiss: () -> Unit,
    onConfirm: (date: String, title: String, description: String) -> Unit,
) {
    var date by remember { mutableStateOf(currentDateIso()) }
    var title by remember { mutableStateOf("") }
    var description by remember { mutableStateOf("") }

    Dialog(onDismissRequest = onDismiss) {
        AppCard(modifier = Modifier.fillMaxWidth().padding(horizontal = 12.dp).widthIn(max = 460.dp)) {
            Text("Новое занятие", color = GradeTheme.colors.textPrimary, fontWeight = FontWeight.Bold, fontSize = 20.sp)
            DatePickerField(
                value = date,
                onValueChange = { date = it },
                label = "Дата",
                modifier = Modifier.padding(top = 12.dp),
            )
            AppTextField(
                title,
                { title = it },
                "Тема занятия (необязательно)",
                modifier = Modifier.padding(top = 8.dp),
            )
            AppTextField(
                description,
                { description = it },
                "Описание темы (необязательно)",
                modifier = Modifier.padding(top = 8.dp).heightIn(min = 96.dp),
                singleLine = false,
            )
            Row(
                modifier = Modifier.fillMaxWidth().padding(top = 16.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                SecondaryButton(text = "Отмена", onClick = onDismiss, modifier = Modifier.weight(1f))
                PrimaryButton(
                    text = "Добавить",
                    enabled = date.isNotBlank(),
                    onClick = {
                        onConfirm(
                            date.trim(),
                            title.trim().ifBlank { date.trim() },
                            description.trim(),
                        )
                    },
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}
